// // Make sure this file has proper export at the end
// import React from "react";
// import { motion } from "framer-motion";
// import { useInView } from "react-intersection-observer";
// import {
//   FaHome,
//   FaCouch,
//   FaUtensils,
//   FaShieldAlt,
//   FaStar,
//   FaCheckCircle,
// } from "react-icons/fa";

// const AboutSectionInside = () => {
//   const [ref, inView] = useInView({
//     triggerOnce: true,
//     threshold: 0.1,
//   });

//   // Apartment features
//   const features = [
//     { icon: <FaHome />, text: "Spacious interiors" },
//     { icon: <FaCouch />, text: "Contemporary décor" },
//     { icon: <FaUtensils />, text: "Fully equipped kitchens" },
//     { icon: <FaStar />, text: "Premium furnishings" },
//     { icon: <FaShieldAlt />, text: "Secure and private environment" },
//   ];

//   // Animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.15,
//         delayChildren: 0.2,
//       },
//     },
//   };

//   const itemVariants = {
//     hidden: { y: 30, opacity: 0 },
//     visible: {
//       y: 0,
//       opacity: 1,
//       transition: { duration: 0.6, ease: "easeOut" },
//     },
//   };

//   return (
//     <section className="py-12 relative overflow-hidden">
//       <div className="container-custom relative z-10">
//         <div className="grid grid-cols-1 lg:grid-cols-2 md:gap-16 gap-8 items-center">
//           {/* Left Side - Content */}
//           <motion.div
//             ref={ref}
//             variants={containerVariants}
//             initial="hidden"
//             animate={inView ? "visible" : "hidden"}
//             className="space-y-4"
//           >
//             <div className="flex items-center gap-3">
//               <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//               <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
//                 ABOUT US
//               </span>
//               <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
//             </div>

//             {/* Heading */}
//             <motion.h2
//               variants={itemVariants}
//               className="text-4xl md:text-5xl font-light text-[#1a2b3c] leading-tight"
//             >
//               About <span className="font-bold text-[#c9a86c]">Stay IN</span>{" "}
//               Hospitality
//             </motion.h2>

//             {/* Description Paragraph 1 */}
//             <motion.p
//               variants={itemVariants}
//               className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed"
//             >
//               Stay IN Hospitality redefines luxury serviced living in Islamabad.
//               Situated in one of the city's most prestigious locations, our
//               residences offer a perfect blend of elegance, functionality, and
//               modern urban comfort.
//             </motion.p>

//             {/* Features List with Icons */}
//             <motion.div variants={itemVariants} className="space-y-4">
//               <p className="text-gray-700 font-medium">
//                 Each apartment is thoughtfully designed to provide:
//               </p>

//               <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
//                 {features.map((feature, index) => (
//                   <motion.div
//                     key={index}
//                     variants={itemVariants}
//                     className="flex items-center gap-3 group"
//                   >
//                     <div className="flex-shrink-0 w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center group-hover:bg-[#c9a86c] transition-colors duration-300">
//                       <span className="text-[#c9a86c] text-xl group-hover:text-white transition-colors duration-300">
//                         {feature.icon}
//                       </span>
//                     </div>
//                     <span className="text-gray-600 md:text-[15px] 2xl:text-lg">{feature.text}</span>
//                   </motion.div>
//                 ))}
//               </div>
//             </motion.div>

//             {/* Description Paragraph 2 - Goal */}
//             <motion.p
//               variants={itemVariants}
//               className="md:text-[17px] 2xl:text-lg text-gray-600 animate-fade-in-up animation-delay-400 italic pt-4 border-l-4 border-[#c9a86c] pl-4"
//             >
//               Our goal is simple — to create a living space that feels exclusive
//               yet welcoming.
//             </motion.p>
//           </motion.div>

//           {/* Right Side - Visual Elements */}
//           <motion.div
//             variants={containerVariants}
//             initial="hidden"
//             animate={inView ? "visible" : "hidden"}
//             className="space-y-4"
//           >
//             {/* Luxury Badge */}
//             <motion.div
//               variants={itemVariants}
//               className="p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 group"
//             >
//               <div className="flex items-center gap-4 mb-0">
//                 <div className="w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a86c] transition">
//                   <span className="text-[#c9a86c] text-xl group-hover:text-white transition-colors duration-300">
//                     <FaStar />
//                   </span>
//                 </div>
//                 <div>
//                   <h3 className="text-lg 2xl:text-xl font-semibold text-[#1a2b3c]">
//                     Luxury Redefined
//                   </h3>
//                   <p className="md:text-[17px] 2xl:text-lg text-gray-600">
//                     Premium serviced living
//                   </p>
//                 </div>
//               </div>

//               <div className="grid grid-cols-2 gap-4">
//                 <div className="text-center p-1  rounded-xl">
//                   <div className="text-xl font-bold text-[#c9a86c]">100%</div>
//                   <div className="text-xs text-gray-600">Furnished</div>
//                 </div>
//                 <div className="text-center p-1 rounded-xl">
//                   <div className="text-xl font-bold text-[#c9a86c]">24/7</div>
//                   <div className="text-xs text-gray-600">Privacy</div>
//                 </div>
//               </div>
//             </motion.div>

//             {/* Feature Highlights Card */}
//             <motion.div
//               variants={itemVariants}
//               className="p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 group"
//             >
//               <h4 className="text-lg 2xl:text-xl font-semibold text-[#1a2b3c] mb-4 flex items-center gap-2">
//                 {/* <FaCheckCircle className="text-[#c9a86c]" /> */}
//                 What Makes Us Different
//               </h4>

//               <div className="space-y-3">
//                 <div className="flex items-center gap-3">
//                   <div className="w-2 h-2 bg-[#c9a86c] rounded-full"></div>
//                   <span className="text-[15px] 2xl:text-lg text-gray-600">
//                     Prestigious Centaurus location
//                   </span>
//                 </div>
//                 <div className="flex items-center gap-3">
//                   <div className="w-2 h-2 bg-[#c9a86c] rounded-full"></div>
//                   <span className="text-[15px] 2xl:text-lg text-gray-600">
//                     Elegance meets functionality
//                   </span>
//                 </div>
//                 <div className="flex items-center gap-3">
//                   <div className="w-2 h-2 bg-[#c9a86c] rounded-full"></div>
//                   <span className="text-[15px] 2xl:text-lg text-gray-600">
//                     Modern urban comfort
//                   </span>
//                 </div>
//                 <div className="flex items-center gap-3">
//                   <div className="w-2 h-2 bg-[#c9a86c] rounded-full"></div>
//                   <span className="text-[15px] 2xl:text-lg text-gray-600">
//                     Exclusive yet welcoming
//                   </span>
//                 </div>
//               </div>
//             </motion.div>

//             {/* Prestigious Location Badge */}
//             <motion.div
//               variants={itemVariants}
//               className="p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 flex items-center gap-3 bg-[#c9a86c]/5 px-8 py-4 border border-[#c9a86c]/20"
//             >
//               <div className="w-14 h-14 bg-[#c9a86c] rounded-full flex items-center justify-center text-white font-bold text-lg">
//                 #1
//               </div>
//               <p className="text-gray-700">
//                 <span className="text-lg 2xl:text-xl font-semibold text-[#1a2b3c]">
//                   Islamabad's most prestigious location
//                 </span>
//                 <br />
//                 <span className="text-[15px] 2xl:text-lg">In the heart of Centaurus</span>
//               </p>
//             </motion.div>
//           </motion.div>
//         </div>
//       </div>
//     </section>
//   );
// };

// // ✅ MAKE SURE THIS EXPORT IS AT THE BOTTOM
// export default AboutSectionInside;




// Make sure this file has proper export at the end
import React from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import {
  FaHome,
  FaCouch,
  FaUtensils,
  FaShieldAlt,
  FaStar,
  FaCheckCircle,
} from "react-icons/fa";

const AboutSectionInside = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  // Apartment features
  const features = [
    { icon: <FaHome />, text: "Spacious interiors" },
    { icon: <FaCouch />, text: "Contemporary décor" },
    { icon: <FaUtensils />, text: "Fully equipped kitchens" },
    { icon: <FaStar />, text: "Premium furnishings" },
    { icon: <FaShieldAlt />, text: "Secure and private environment" },
  ];

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.6, ease: "easeOut" },
    },
  };

  return (
    <>
      {/* SEO Meta Tags for About Section */}
      <Helmet>
        <title>About StayIN Hospitality | Luxury Serviced Apartments Centaurus Islamabad</title>
        <meta name="description" content="StayIN Hospitality redefines luxury serviced living in Islamabad's prestigious Centaurus location. Fully furnished apartments with spacious interiors, contemporary décor, and 24/7 privacy. Experience elegance and comfort." />
        <meta name="keywords" content="StayIN Hospitality, luxury serviced apartments Islamabad, Centaurus apartments, fully furnished apartments Islamabad, premium living Islamabad, serviced residences Islamabad" />
      </Helmet>

      {/* Organization Schema for Hospitality Business */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LodgingBusiness",
          "name": "StayIN Hospitality",
          "description": "Luxury serviced apartments in Centaurus Islamabad offering premium living with spacious interiors, contemporary décor, and fully equipped kitchens.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Centaurus Complex, Jinnah Avenue",
            "addressLocality": "Islamabad",
            "addressCountry": "PK"
          },
          "areaServed": "Islamabad",
          "priceRange": "$$$",
          "amenityFeature": features.map(feature => ({
            "@type": "LocationFeatureSpecification",
            "name": feature.text,
            "value": true
          })),
          "brand": {
            "@type": "Brand",
            "name": "StayIN Hospitality"
          }
        })}
      </script>

      <section 
        className="py-12 relative overflow-hidden"
        aria-label="About StayIN Hospitality - Luxury serviced apartments in Centaurus Islamabad"
      >
        <div className="container-custom relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 md:gap-16 gap-8 items-center">
            {/* Left Side - Content */}
            <motion.div
              ref={ref}
              variants={containerVariants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              className="space-y-4"
            >
              <div className="flex items-center gap-3">
                <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
                <span className="text-[#c9a86c] font-medium tracking-[0.2em] text-xs uppercase">
                  ABOUT US
                </span>
                <div className="w-12 h-[2px] bg-[#c9a86c]"></div>
              </div>

              {/* Heading */}
              <motion.h2
                variants={itemVariants}
                className="text-4xl md:text-5xl font-light text-[#1a2b3c] leading-tight"
              >
                About <span className="font-bold text-[#c9a86c]">Stay IN</span>{" "}
                Hospitality
              </motion.h2>

              {/* Description Paragraph 1 */}
              <motion.p
                variants={itemVariants}
                className="md:text-[17px] 2xl:text-lg mb-10 text-gray-600 animate-fade-in-up animation-delay-400 leading-relaxed"
              >
                Stay IN Hospitality redefines luxury serviced living in Islamabad.
                Situated in one of the city's most prestigious locations, our
                residences offer a perfect blend of elegance, functionality, and
                modern urban comfort.
              </motion.p>

              {/* Features List with Icons */}
              <motion.div variants={itemVariants} className="space-y-4">
                <p className="text-gray-700 font-medium">
                  Each apartment is thoughtfully designed to provide:
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  {features.map((feature, index) => (
                    <motion.div
                      key={index}
                      variants={itemVariants}
                      className="flex items-center gap-3 group"
                    >
                      <div className="flex-shrink-0 w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center group-hover:bg-[#c9a86c] transition-colors duration-300">
                        <span className="text-[#c9a86c] text-xl group-hover:text-white transition-colors duration-300">
                          {feature.icon}
                        </span>
                      </div>
                      <span className="text-gray-600 md:text-[15px] 2xl:text-lg">{feature.text}</span>
                    </motion.div>
                  ))}
                </div>
              </motion.div>

              {/* Description Paragraph 2 - Goal */}
              <motion.p
                variants={itemVariants}
                className="md:text-[17px] 2xl:text-lg text-gray-600 animate-fade-in-up animation-delay-400 italic pt-4 border-l-4 border-[#c9a86c] pl-4"
              >
                Our goal is simple — to create a living space that feels exclusive
                yet welcoming.
              </motion.p>
            </motion.div>

            {/* Right Side - Visual Elements */}
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              className="space-y-4"
            >
              {/* Luxury Badge */}
              <motion.div
                variants={itemVariants}
                className="p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 group"
              >
                <div className="flex items-center gap-4 mb-0">
                  <div className="w-14 h-14 bg-[#c9a86c]/10 rounded-full flex items-center justify-center mb-4 group-hover:bg-[#c9a86c] transition">
                    <span className="text-[#c9a86c] text-xl group-hover:text-white transition-colors duration-300">
                      <FaStar />
                    </span>
                  </div>
                  <div>
                    <h3 className="text-lg 2xl:text-xl font-semibold text-[#1a2b3c]">
                      Luxury Redefined
                    </h3>
                    <p className="md:text-[17px] 2xl:text-lg text-gray-600">
                      Premium serviced living
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="text-center p-1 rounded-xl">
                    <div className="text-xl font-bold text-[#c9a86c]">100%</div>
                    <div className="text-xs text-gray-600">Furnished</div>
                  </div>
                  <div className="text-center p-1 rounded-xl">
                    <div className="text-xl font-bold text-[#c9a86c]">24/7</div>
                    <div className="text-xs text-gray-600">Privacy</div>
                  </div>
                </div>
              </motion.div>

              {/* Feature Highlights Card */}
              <motion.div
                variants={itemVariants}
                className="p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 group"
              >
                <h4 className="text-lg 2xl:text-xl font-semibold text-[#1a2b3c] mb-4 flex items-center gap-2">
                  What Makes Us Different
                </h4>

                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#c9a86c] rounded-full"></div>
                    <span className="text-[15px] 2xl:text-lg text-gray-600">
                      Prestigious Centaurus location
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#c9a86c] rounded-full"></div>
                    <span className="text-[15px] 2xl:text-lg text-gray-600">
                      Elegance meets functionality
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#c9a86c] rounded-full"></div>
                    <span className="text-[15px] 2xl:text-lg text-gray-600">
                      Modern urban comfort
                    </span>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-2 h-2 bg-[#c9a86c] rounded-full"></div>
                    <span className="text-[15px] 2xl:text-lg text-gray-600">
                      Exclusive yet welcoming
                    </span>
                  </div>
                </div>
              </motion.div>

              {/* Prestigious Location Badge */}
              <motion.div
                variants={itemVariants}
                className="p-6 rounded-2xl bg-white shadow-lg hover:shadow-xl transition duration-300 border border-gray-100 flex items-center gap-3 bg-[#c9a86c]/5 px-8 py-4 border border-[#c9a86c]/20"
              >
                <div className="w-14 h-14 bg-[#c9a86c] rounded-full flex items-center justify-center text-white font-bold text-lg">
                  #1
                </div>
                <p className="text-gray-700">
                  <span className="text-lg 2xl:text-xl font-semibold text-[#1a2b3c]">
                    Islamabad's most prestigious location
                  </span>
                  <br />
                  <span className="text-[15px] 2xl:text-lg">In the heart of Centaurus</span>
                </p>
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutSectionInside;